import { render, staticRenderFns } from "./rateLook.vue?vue&type=template&id=db6be66c&"
import script from "./rateLook.vue?vue&type=script&lang=js&"
export * from "./rateLook.vue?vue&type=script&lang=js&"
import style0 from "./rateLook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports